import type { ComponentProps } from 'react';
import { cn } from '../lib/utils.js';
import { buttonVariants } from './button-variants.js';

export type IconButtonProps = Omit<ComponentProps<'button'>, 'aria-label'> & {
  /** Nombre accesible obligatorio: el boton solo muestra un icono. */
  label: string;
  size?: 'sm' | 'default';
  active?: boolean;
};

/**
 * Boton de solo icono con nombre accesible obligatorio.
 *
 * @example
 * <IconButton label="Duplicar" onClick={duplicate}><Copy /></IconButton>
 */
export function IconButton({
  label,
  size = 'sm',
  active = false,
  className,
  type = 'button',
  ...props
}: IconButtonProps) {
  return (
    <button
      type={type}
      aria-label={label}
      aria-pressed={active ? true : undefined}
      data-slot="icon-button"
      className={cn(
        buttonVariants({ variant: 'ghost', size: 'icon' }),
        size === 'sm' ? 'size-7 [&_svg]:size-3.5' : 'size-8',
        'text-muted-foreground hover:text-foreground',
        active && 'bg-accent text-foreground',
        className,
      )}
      {...props}
    />
  );
}
